import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import LineItem from "./line-item"

const Details = ({ data }) => {
  const { addons, line_items } = data

  return (
    <Box mt={4}>
      <Typography as="h2" fontSize="26px" fontWeight="500" lineHeight="30px">
        Order Details
      </Typography>
      {line_items.map((item, i) => (
        <LineItem item={item} key={`${item.title}-${i}`} />
      ))}
      {addons.map((addon, i) => (
        <LineItem item={addon} key={`${addon.title}-${i}`} />
      ))}
    </Box>
  )
}

Details.propTypes = {
  data: PropTypes.object,
}

export default Details
